import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

import SubLayout from "@/containers/layout/LandingLayout/SubLayout";
import routes from "@/constants/routes";

const Hero: FC = () => {
  return (
    <div className="w-full text-white pt-7 md:pt-0 x xl:pt-24 bg-landing-blue">
      <SubLayout>
        <div className="flex flex-col items-center justify-center mx-auto xl:max-w-6xl 3xl:max-w-screen-2xl md:flex-row md:pb-11 xl:pb-24">
          <div className="w-full xl:ml-0 md:w-1/2 md:pt-0 ">
            <h1 className="md:w-[41rem] font-bold text-[2.625rem] xl:text-5xl leading-[49px] xl:leading-[61px]">
              <span className="text-landing-orange">Our mission </span>
              <span> is to make home ownership a reality again.</span>
            </h1>
            <h2 className="text-base xl:text-lg mt-9 md:mt-4 xl:mt-7 w-full md:w-[21.75rem] xl:w-[33rem]">
              Buying a home shouldn’t be so hard. Today, millions of us are locked out because we
              can’t get a mortgage for a home we could afford to rent.
            </h2>
            <h2 className="text-base xl:text-lg  md:mt-4 xl:mt-7 mt-7 w-full md:w-[21.75rem] xl:w-[33rem]">
              At Keyzy, we’re here to change that. Our innovative rent to buy solution can make home
              ownership in the UK a reality again.
            </h2>
            <div className="flex flex-col md:flex-row md:space-x-4">
              <Link href={routes.register}>
                <a className="min-w-[9rem] flex items-center justify-center md:max-w-fit w-full ml:0 md:w-auto px-4 py-3 text-base font-bold transition duration-300 ease-in-out transform rounded shadow mt-7 xl:mt-12 bg-landing-orange text-landing-blue hover:scale-105">
                  Apply now
                </a>
              </Link>
              <Link href={routes.searchHomes}>
                <a className="min-w-[9rem] flex items-center justify-center md:max-w-fit w-full ml:0 md:w-auto px-4 py-3 text-base font-bold transition duration-300 ease-in-out transform rounded shadow mt-7 xl:mt-12 bg-landing-cherry text-landing-white hover:scale-105">
                  Browse homes
                </a>
              </Link>
            </div>
          </div>

          <div className="w-[27.75rem] md:ml-4 md:w-1/2 md:mt-14 xl:mt-0 mt-11 pb-8">
            <div className="-right-10 xs:right-auto md:top-10 xl:top-auto h-72 xl:w-[34.5rem] xl:h-[28em] relative md:w-full md:h-[20.5rem] md:ml-auto ">
              {/* Desktop/Tablet image */}
              <div className="hidden md:block absolute inset-0">
                <Image
                  src="/about/hero-image.svg"
                  alt="home image"
                  objectFit="contain"
                  priority
                  layout="fill"
                  loading="eager"
                />
              </div>
              {/* Mobile image */}
              <div className="block md:hidden absolute inset-0">
                <Image
                  src="/about/hero-image-mobile.svg"
                  alt="home image"
                  objectFit="contain"
                  priority
                  layout="fill"
                  loading="eager"
                />
              </div>
            </div>
          </div>
        </div>
      </SubLayout>
    </div>
  );
};

export default Hero;
